/* eslint import/prefer-default-export: ["off"] */
export const SET_LOADING = 'SET_LOADING';
